<div class="nav-tabs">
  <a  routerLink="bookmarks" routerLinkActive="selected" class="tabs bookmark-tab">
    <div class="tab-title">
      <i class="material-icons-outlined">bookmarks</i>
    </div>
  </a>
  <a  routerLink="todos" routerLinkActive="selected"  class="tabs todo-tab">
    <div class="tab-title">
      <i class="material-icons-outlined">check</i>
    </div>
  </a>
  <a  routerLink="notes"  routerLinkActive="selected" class="tabs notes-tab">
    <div class="tab-title">
      <i class="material-icons-outlined">notes</i>
    </div>
  </a>
</div>